module.exports = __webpack_public_path__ + "static/img/1049@2x.e4b6f9ef.png";